import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ALERT_FILTERS } from '../../../../features/B5/alerts-list';
import { ClientAlertsTab, type AlertsTabSearch } from '../../../../features/B5/client-alerts-page';

const Search = z.object({
  tplLang: z.enum(['he', 'en']).optional().catch(undefined),
  pv: z.enum(['single', 'batch']).optional().catch(undefined),
  status: z.enum(ALERT_FILTERS).optional().catch(undefined),
});

export const Route = createFileRoute('/_app/client/$clientId/alerts')({
  validateSearch: (s) => Search.parse(s),
  component: AlertsTab,
});

function AlertsTab() {
  const { clientId } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <ClientAlertsTab
      clientId={clientId}
      search={{ tplLang: search.tplLang, pv: search.pv ?? 'single', status: search.status ?? '' }}
      setSearch={(patch: Partial<AlertsTabSearch>) => void navigate({ search: (prev) => ({ ...prev, ...patch, status: (patch.status ?? prev.status) || undefined }), replace: true })}
    />
  );
}
